import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage/LandingPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import Header from './components/Header';
import Footer from './components/Footer';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col min-h-screen bg-white" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<LandingPage data-id="element-6" />} data-id="element-5" />
            <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-8" />} data-id="element-7" />
            <Route path="/terms-of-service" element={<TermsOfService data-id="element-10" />} data-id="element-9" />
          </Routes>
        </main>
        <Footer data-id="element-11" />
      </div>
    </BrowserRouter>;
}